/**
 * Error tag prefixes used by the tensorflow worker to mark specific
 * known failure modes. The main thread checks for these prefixes to
 * route errors to the right Sentry category without string-matching
 * on third-party library messages.
 */
export const WORKER_ERROR_TAGS = {
  WEBGL_SHADER: '[WEBGL_SHADER_ERROR]',
  YOLO_EMPTY_LIST: '[YOLO_EMPTY_LIST]',
} as const;
